<template>

	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{ $t('excel-export.title') }}
				</div>
				<b-form @submit.prevent="submitFile">
					<b-form-group v-if="!isOk">
						<b-container>
							<b-row>
								<b-col cols="4">
									<b-form-group :label="$t('excel-export.from-dep')">
									</b-form-group>
									<b-form-select
										v-model="fromDep"
										v-validate="'required'"
										name="fromDep"
										:class="{ 'is-invalid': submitted && errors.has('fromDep') }"
									>
										<option v-for="(selectOption, indexOpt) in allDeps"
												:key="indexOpt"
												:value="selectOption.id"
												:disabled="selectOption.id === toDep"
										>
											{{ selectOption.name }}
										</option>
										<template slot="first">
											<option :value="null" disabled>-- {{ $t('promo-to-product.department') }} --</option>
										</template>
									</b-form-select>
									<b-form-group>
										<div v-if="submitted && errors.has('fromDep')" class="invalid-feedback">{{ errors.first('fromDep') }}</div>
									</b-form-group>

								</b-col>
								<b-col cols="4">
									<b-form-group :label="$t('excel-export.to-dep')">
									</b-form-group>
									<b-form-select
										v-model="toDep"
										v-validate="'required'"
										name="toDep"
										:class="{ 'is-invalid': submitted && errors.has('toDep') }"
									>
										<option v-for="(selectOption, indexOpt) in allDeps"
												:key="indexOpt"
												:value="selectOption.id"
												:disabled="selectOption.id === fromDep"
										>
											{{ selectOption.name }}
										</option>
										<template slot="first">
											<option :value="null" disabled>-- {{ $t('promo-to-product.department') }} --</option>
										</template>
									</b-form-select>
									<b-form-group>
										<div v-if="submitted && errors.has('toDep')" class="invalid-feedback">{{ errors.first('toDep') }}</div>
									</b-form-group>

								</b-col>
								<b-col cols="4">
									<b-form-group :label="$t('excel-export.file')">
									</b-form-group>
									<b-form-file
										v-model="file"
										size="sm"
										:placeholder="$t('excel-export.select')"
										name="file"
										v-validate="'required'"
										:state="Boolean(file)"
										:browse-text="$t('excel-export.browse')"
									>
										<template slot="file-name" slot-scope="{ names }">
											<b-badge variant="dark">{{ names[0] }}</b-badge>
											<b-badge v-if="names.length > 1" variant="dark" class="ml-1">
												+ {{ names.length - 1 }} More files
											</b-badge>
										</template>
									</b-form-file>
									<b-form-group>
										<div v-if="submitted && errors.has('file')" class="invalid-feedback">{{ errors.first('file') }}</div>
									</b-form-group>
								</b-col>



							</b-row>
							<b-row align-self="center">
								<b-col align-self="center" cols="12"><b-button type="submit" class="pull-right" variant="success">{{$t('excel-export.export')}}</b-button></b-col>
							</b-row>
						</b-container>
					</b-form-group>
				</b-form>
				<b-form-group v-if="isOk">
					<b-alert
						show
						dismissible
						variant="success"
					>
						<b> <i class="fa fa-check-circle" aria-hidden="true"></i> Success </b>
					</b-alert>
					<b-row>
						<b-col cols="12">
							<b-button variant="success" class="pull-right" @click="setIsOkFalse()">{{ $t('excel-export.againSuccess')}}</b-button>
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group v-if="isError">
						<b-alert
							show
							dismissible
							variant="danger"
						>
							<b> <i class="fa fa-times-circle" aria-hidden="true"></i> {{errorMessage}} </b>
						</b-alert>
						<b-row>
							<b-col cols="12">
								<b-button variant="danger" class="pull-right" @click="setIsErrorFalse()">{{ $t('excel-export.againFail')}}</b-button>
							</b-col>
						</b-row>
					</b-form-group>

			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import { mapGetters,mapActions } from 'vuex'
	import Multiselect from 'vue-multiselect'
	import ApiService from '../../../services/api.service'
	import axios from 'axios'
	export default {
		name: 'ExcelExport',
		data() {
			return {
				file: '',
				fromDep: null,
				toDep: null,
				isOk: false,
				isError: false,
				errorMessage: 'Fail',
				submitted: false,
				dict : {
					custom: {
						fromDep: {
							required: () => this.$t('excel-export.requiredDep')
						},
						toDep: {
							required: () => this.$t('excel-export.requiredDep')
						},
						file: {
							required: () => this.$t('excel-export.requiredFile')
						}
					}
				}
			}
		},
		methods: {
		...mapActions('departments',['getDepartmentsList']),
			submitFile(e){
				this.submitted = true;
				this.$validator.localize('en', this.dict);
				this.$validator.validate().then(valid => {
					if (valid) {
						let formData = new FormData()
						formData.append('upload', this.file)
						this.axios.post(`excel-parser/read-file/${this.fromDep}/${this.toDep}`,
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							}
						).then(response =>{
							if(response.data === "SUCCESS"){
								this.isOk = true
							}else{
								this.errorMessage = " 500 ERROR !!!"
								this.isError = true
							}



						}).catch(error =>{

						})

						this.file = ''
						this.fromDep =  null
						this.toDep =  null
					}
				});


			},
			setIsOkFalse(){
				this.isOk = false
			},
			setIsErrorFalse(){
				this.isError = false
			}
		},
		created() {
			this.getDepartmentsList()
		},
		computed: {
			...mapGetters('departments',{
				'allDeps': 'getDepartments'
			})
		},
		components: {
			Multiselect
		},
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.alert {
		padding:15px;
	}
	.invalid-feedback {
		display: block;
	}

</style>
